"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetDataCard = void 0;
var React = require("react");
var Icons_1 = require("../../_Core/Icons");
var Keyboard_1 = require("../../_Core/Keyboard");
var CircularButton_1 = require("../../Buttons/CircularButton/CircularButton");
var ToggleSwitch_1 = require("../../Buttons/ToggleSwitch/ToggleSwitch");
var Icons_2 = require("../../Icons");
var Localization_1 = require("../../Localization");
var Theme_1 = require("../../Theme");
var WidgetDataCard_styles_1 = require("./WidgetDataCard.styles");
var WidgetDataCard = /** @class */ (function (_super) {
    __extends(WidgetDataCard, _super);
    function WidgetDataCard(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleHover = function () {
            _this.setState({ IsHovered: !_this.state.IsHovered });
        };
        _this.handleDeleteButtonClicked = function (e) {
            e.stopPropagation();
            return _this.props.OnDeleteClicked && _this.props.OnDeleteClicked();
        };
        _this.handleDownButtonClicked = function (e) {
            e.stopPropagation();
            return _this.props.OnDownClick && _this.props.OnDownClick();
        };
        _this.handleUpButtonClicked = function (e) {
            e.stopPropagation();
            return _this.props.OnUpClick && _this.props.OnUpClick();
        };
        _this.handleKeyDown = function (e) {
            e.stopPropagation();
            if (Keyboard_1.IsKeySpace(e) && e.target.id === _this.props.Caption) {
                e.preventDefault();
            }
        };
        _this.handleKeyUp = function (e) {
            e.stopPropagation();
            if (Keyboard_1.IsKeySpace(e) && e.target.id === _this.props.Caption) {
                _this.toggleExpanded(e);
            }
        };
        _this.toggleExpanded = function (e) {
            e.stopPropagation();
            _this.setState({ Collapsed: !_this.state.Collapsed });
        };
        _this.handleToggleToggled = function () {
            _this.setState({
                Collapsed: _this.state.Enabled,
                Enabled: !_this.state.Enabled,
            }, function () {
                return _this.props.OnEnableToggled && _this.props.OnEnableToggled(_this.state.Enabled);
            });
        };
        _this.state = {
            Collapsed: _this.props.Collapsed,
            Enabled: _this.props.IsEnabled,
            IsHovered: false,
        };
        return _this;
    }
    WidgetDataCard.prototype.render = function () {
        var deleteButton = this.props.DisplayDeleteButton ? (React.createElement(WidgetDataCard_styles_1.HeaderItem, null,
            React.createElement(CircularButton_1.CircularButton, { Icon: Icons_1.Icons.CloseThick, AriaLabel: "" + Localization_1.strings.WidgetDataCard_Action_Delete, OnClick: this.handleDeleteButtonClicked }))) : null;
        var content = React.createElement(WidgetDataCard_styles_1.ContentDiv, null, this.props.children);
        return (React.createElement(WidgetDataCard_styles_1.Wrapper, { tabIndex: 0, id: this.props.Caption, role: "listitem", onKeyUp: this.handleKeyUp, onKeyDown: this.handleKeyDown, "aria-expanded": !this.state.Collapsed },
            React.createElement(WidgetDataCard_styles_1.Header, { onClick: this.toggleExpanded, onMouseOver: this.toggleHover, onMouseOut: this.toggleHover, role: "button", "aria-label": (this.state.Collapsed ? Localization_1.strings.WidgetDataCard_Action_Expand : Localization_1.strings.WidgetDataCard_Action_Collapse) + " " + this.props.Caption, "aria-expanded": !this.state.Collapsed },
                React.createElement(WidgetDataCard_styles_1.CaptionBar, { style: { color: this.state.IsHovered ? Theme_1.Color.Blue.B60 : undefined } },
                    React.createElement(WidgetDataCard_styles_1.ChevronHolder, { style: this.state.IsHovered ? { color: Theme_1.Color.Grey.G10, backgroundColor: Theme_1.Color.Blue.B60 } : undefined }, this.state.Collapsed ? React.createElement(Icons_2.ChevronRightIcon, { Height: "15px", Width: "15px" }) : React.createElement(Icons_2.ChevronDownIcon, { Height: "15px", Width: "15px" })),
                    this.props.Caption),
                React.createElement(WidgetDataCard_styles_1.Buttons, null,
                    deleteButton,
                    React.createElement(WidgetDataCard_styles_1.HeaderItem, null,
                        React.createElement(CircularButton_1.CircularButton, { Icon: Icons_1.Icons.ChevronDown, AriaLabel: "" + Localization_1.strings.WidgetDataCard_Action_Down, OnClick: this.handleDownButtonClicked, Disabled: this.props.IsBottommost })),
                    React.createElement(WidgetDataCard_styles_1.HeaderItem, null,
                        React.createElement(CircularButton_1.CircularButton, { Icon: Icons_1.Icons.ChevronUp, AriaLabel: "" + Localization_1.strings.WidgetDataCard_Action_Up, OnClick: this.handleUpButtonClicked, Disabled: this.props.IsTopmost })),
                    React.createElement(WidgetDataCard_styles_1.HeaderItem, null,
                        React.createElement(ToggleSwitch_1.ToggleSwitch, { OnChange: this.handleToggleToggled, Value: this.state.Enabled })))),
            React.createElement(WidgetDataCard_styles_1.Content, { style: { display: this.state.Collapsed ? "none" : "block" } }, content)));
    };
    return WidgetDataCard;
}(React.Component));
exports.WidgetDataCard = WidgetDataCard;
